import React from 'react'

import { FormContainer } from 'react-hook-form-mui'
import { submitStudentSurvey } from '../../store/slices/studentSurveyListSlice/apis'
import { useNavigate, useParams } from 'react-router-dom'
import ROUTES from '../../consts/paths'
import CustomHeader from '../../components/CustomHeader'
import { useAppDispatch } from '../../store'
import { getStudentSelectedSurvey } from '../../store/slices/studentSurveyListSlice/selectors'
import { notification } from '../../components/Notifications'
import PageHeader from '../../components/PageHeader'
import { type OnSubmitFn } from './components/SurveyFeatureStepper/types'
import { StepperContextProvider } from './components/SurveyFeatureStepper/useStepper'
import { RenderSections } from './components/RenderSections'

const SurveyFeatureWithStepper: React.FC = (): JSX.Element => (
  <StepperContextProvider>
    <SurveyFeature />
  </StepperContextProvider>
)

const SurveyFeature: React.FC = (): JSX.Element => {
  const dispatch = useAppDispatch()
  const { id } = useParams()
  const survey = getStudentSelectedSurvey()
  const navigate = useNavigate()
  const surveyResponseMap: Record<string, string | undefined> = {}

  const onSubmit: OnSubmitFn = async (responseItems): Promise<void> => {
    const payload = {
      status: 'Submitted',
      surveyResponseItems: responseItems
    }
    try {
      if (survey) {
        const res = await dispatch(submitStudentSurvey({ urlId: id, data: payload })).unwrap()
        if (res) navigate(ROUTES.SURVEY_COMPLETED)
      }
    } catch (error: any) {
      notification(error?.message ?? 'An error occoured while submitting this survey', { variant: 'error' })
    }
  }

  const instructorTitles = survey ? survey.instructors?.map(instructor => instructor.title).join(', ') : ''
  const description = survey ? `${survey.sectionAbbreviation}${instructorTitles ? ', ' + instructorTitles : ''}` : ''
  return (
    <React.Fragment>
     <CustomHeader info={survey?.sectionAbbreviation} />
      <FormContainer defaultValues={surveyResponseMap}>
        <PageHeader
          title={survey ? survey.distributionSeriesTitle : ''}
          description={description}
          isCompactOnly
          showBackButton
        />

        <RenderSections rawSections={survey?.surveySections ?? []} onSubmit={onSubmit} />
      </FormContainer>
    </React.Fragment>
  )
}

export default SurveyFeatureWithStepper
